export enum AccessLevel {
    Public = 'PUBLIC',
    Trial = 'TRIAL',
    FreeTier = 'FREE_TIER',
    ProPlan = 'PRO_PLAN',
}
